import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Button from 'components/Button/Button';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import {
	DeviceFullInfoContext,
	IDeviceFullInfoContext,
} from 'modules/Devices/DeviceFullInfo/deviceFullInfoState/deviceFullInfoContext';
import style from './EditBtn.module.scss';

const EditBtn: React.FC = () => {
	const { deviceForFullInfo } = useContext<IDeviceFullInfoContext>(DeviceFullInfoContext);

	return (
		<Link to={`/devices/edit?deviceID=${deviceForFullInfo?.id}`} data-test="EditBtn">
			<Button
				className={style.btn}
				theme="primaryBlue"
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#pencil`} />
					</svg>
				}>
				<Text translationNameSpace="form" translationKey="editDeviceButton" asFragment={true} />
			</Button>
		</Link>
	);
};

export default EditBtn;
